module.exports = __webpack_public_path__ + "static/media/long-arrow-up.8a695fa2.svg";